import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {GlobalStyle} from './GlobalStyle';
import GuestRoute from './utils/GuestRoute';
import ProtectedRoute from './utils/ProtectedRoute';

//Pages
import {ConfigProvider, theme} from "antd";
import {CookieConsent} from "react-cookie-consent";
import {Toaster} from "react-hot-toast";
import LayoutComponent from "./components/Layout";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import DoctorProfilePage from './pages/DoctorProfilePage';
import UnauthorizedPage from "./pages/errorPages/unauthorized.page";
import FaceDetectionPage from './pages/FaceDetectionPage';
import ForgotPasswordPage from './pages/ForgetPasswordPage';
import HelpPage from './pages/HelpPage';
import HomePage from './pages/HomePage';
import GlaciesAIChat from './pages/GlaciesAIChat/GlaciesAIChat.page';
import InvitationVerifyAndSignUpPage from './pages/InvitationVerifyAndSignUpPage';
import LoginPage from './pages/LoginPage';
import PatientsListPage from "./pages/org-users/users-patient/users-patient.page";
import UsersListPage from "./pages/org-users/users.page";
import OrganizationPage from "./pages/organization/organization.page";
import CameraPage from "./pages/PatientCabinet/FileManagement/camera/camera.page";
import CompareFilesPage from "./pages/PatientCabinet/FileManagement/CompareFiles.page";
import FileUploadPage from "./pages/PatientCabinet/FileManagement/FileUploadPage";
import OpenInMobilePage from "./pages/PatientCabinet/FileManagement/open-in-mobile.page";
import VisualAnalysis from "./pages/PatientCabinet/FileManagement/VisualAnalysis";
import AiAnalysisPage from "./pages/PatientCabinet/pages/ai-analysis/ai-analysis.page";
import Wrinkles from "./pages/PatientCabinet/pages/wrinkles.page";
import PatientsCabinetPage from './pages/PatientCabinet/PatientsCabinetPage';
import PdfPage from './pages/PatientCabinet/PdfPage';
import PdfView from "./pages/PatientCabinet/PdfView";
import PatientSkinReportDetailPage from "./pages/PatientCabinet/skin-reports/PatientSkinReportDetail";
import PatientSkinReportDetailPageV2 from "./pages/PatientCabinet/skin-reports/PatientSkinReportDetailV2";
import PatientSkinReportLayout from "./pages/PatientCabinet/skin-reports/PatientSkinReportLayout";
import PatientSkinReportPage from "./pages/PatientCabinet/skin-reports/PatientSkinReportPage";
import PatientSurveyDetails from './pages/PatientCabinet/survey/PatientSurveyDetails';
import SubmitPatientSurvey from './pages/PatientCabinet/survey/SubmitPatientSurvey';
import PatientListPage from './pages/PatientListPage';
import PrivacyPage from "./pages/privacy.page";
import ResetPassword from "./pages/ResetPassword";
import PatientSkinReportDetailSharePage from "./pages/standalone/PatientSkinReportDetailShare";
import PatientSkinReportDetailSharePageV2 from "./pages/standalone/PatientSkinReportDetailSharev2";
import PatientSurveySubmitShareNewDesign
    from "./pages/standalone/patientsurveycomponent/PatientSurveySubmitShare_newDesign";
import PatientSurveySubmitShare from './pages/standalone/PatientSurveySubmitShare';
import CSVToJSONConverter from "./pages/standalone/surveyImporter/surve-importer";
import SurveySubmissionStatus from './pages/standalone/SurveySubmissionStatus';
import ImageComparisionPage from "./pages/PatientCabinet/FileManagement/image-comparision.page";
import FollowUpPage from './pages/FollowUpPage';
import NotificationPage from './pages/NotificationPage';
import PartnerReferralsPage from './pages/PartnerReferralsPage';
import PartnerKitsPage from './pages/PartnerKitsPage';

function App() {
    return (
        <Router>
            <ConfigProvider
                theme={{
                    algorithm: theme.darkAlgorithm,
                    components: {
                        Button: {
                            colorPrimary: '#9A3C8B',
                            algorithm: true, // Enable algorithm
                        },
                    }
                }}
            >
                <GlobalStyle/>
                <CookieConsent
                    location="bottom"
                    cookieName="GlaciesCookies"
                    style={{background: "#2B373B"}}
                    buttonStyle={{color: "#4e503b", fontSize: "13px"}}
                    expires={150}
                >
                    This website uses cookies to enhance the user experience.{" "}
                </CookieConsent>
                <LayoutComponent>

                    <Routes>
                        <Route path='/' element={<GuestRoute> <LoginPage/> </GuestRoute>}/>
                        <Route path='/privacy' element={<GuestRoute> <PrivacyPage/> </GuestRoute>}/>
                        <Route path='/login' element={<GuestRoute> <LoginPage/> </GuestRoute>}/>
                        <Route path='/forgot-password' element={<GuestRoute> <ForgotPasswordPage/> </GuestRoute>}/>
                        <Route path='/reset-password' element={<GuestRoute> <ResetPassword/> </GuestRoute>}/>
                        <Route path='/verify' element={<GuestRoute> <InvitationVerifyAndSignUpPage/> </GuestRoute>}/>
                        <Route path='/deeplink' element={<GuestRoute> <OpenInMobilePage/> </GuestRoute>}/>
                        <Route path='/share/v1/:reportId'
                               element={<GuestRoute> <PatientSkinReportDetailSharePage/> </GuestRoute>}/>
                        <Route path='/share/:reportId'
                               element={<GuestRoute> <PatientSkinReportDetailSharePageV2/> </GuestRoute>}/>
                        <Route path='/create-survey2'
                               element={<GuestRoute> <PatientSurveySubmitShare/> </GuestRoute>}/>
                        <Route path='/create-survey'
                               element={<GuestRoute> <PatientSurveySubmitShareNewDesign/> </GuestRoute>}/>
                        <Route path='/standalone/survey-status'
                               element={<GuestRoute> <SurveySubmissionStatus/> </GuestRoute>}/>
                        <Route path="/face-detection" element={<FaceDetectionPage/>}/>
                        <Route path='/dashboard' element={<ProtectedRoute> <HomePage/> </ProtectedRoute>}/>
                        <Route path='/help-page' element={<ProtectedRoute> <HelpPage/> </ProtectedRoute>}/>
                        <Route path='/glacies-ai' element={<ProtectedRoute> <GlaciesAIChat/> </ProtectedRoute>}/>
                        <Route path='/patient-list' element={<ProtectedRoute> <PatientListPage/> </ProtectedRoute>}/>
                        <Route path='/survey-import'
                               element={<ProtectedRoute> <CSVToJSONConverter/> </ProtectedRoute>}/>
                        <Route path='patient-cabinet/:patientId' element={<ProtectedRoute/>}>
                            <Route path='' element={<PatientsCabinetPage/>}/>
                            <Route path='wrinkles'>
                                <Route path='' element={<Wrinkles/>}/>
                            </Route>
                            <Route path='ai-analysis'>
                                <Route path='' element={<AiAnalysisPage/>}/>
                            </Route>
                            <Route path='comparison' element={<ImageComparisionPage/>}/>
                            <Route path='skin-report' element={<PatientSkinReportLayout/>}>
                                <Route path='' element={<PatientSkinReportPage/>}/>
                                <Route path=':reportId' element={<PatientSkinReportDetailPageV2/>}/>
                                <Route path=':reportId/v2' element={<PatientSkinReportDetailPage/>}/>
                            </Route>
                            <Route path='skin-report-files'>
                                <Route path='' element={<PdfPage/>}/>
                                <Route path=':pdfid' element={<PdfView/>}/>
                            </Route>
                            <Route path='analysis'>
                                <Route path='' element={<VisualAnalysis/>}/>
                                <Route path='file-upload'>
                                    <Route path='' element={<FileUploadPage/>}/>
                                    <Route path='camera' element={<CameraPage/>}/>
                                </Route>
                                <Route path='compare' element={<CompareFilesPage/>}/>
                                <Route path='wrinkles' element={<CompareFilesPage/>}/>
                            </Route>
                            <Route path='patient-survey/:surveyId' element={<PatientSurveyDetails/>}/>
                            <Route path='patient-create-survey' element={<SubmitPatientSurvey/>}/>
                        
                        </Route>
                        <Route path='/pdf/:patientId' element={<ProtectedRoute> <PdfPage/> </ProtectedRoute>}/>
                        <Route path='/profile' element={<ProtectedRoute> <DoctorProfilePage/> </ProtectedRoute>}/>
                        <Route path='/change-password'
                               element={<ProtectedRoute> <ChangePasswordPage/> </ProtectedRoute>}/>
                        <Route path='/organization'
                               element={<ProtectedRoute role="ORGANIZATION_ADMIN"> <OrganizationPage/>
                               </ProtectedRoute>}/>
                        <Route path='/partner-referrals'
                               element={<ProtectedRoute role="ORGANIZATION_ADMIN"><PartnerReferralsPage/></ProtectedRoute>}/>
                        <Route path='/partner-kits'
                               element={<ProtectedRoute role="ORGANIZATION_ADMIN"><PartnerKitsPage/></ProtectedRoute>}/>
                        <Route path='/org-users' element={
                            <ProtectedRoute role="ORGANIZATION_ADMIN"/>
                        }>
                            <Route path='' element={<UsersListPage/>}/>
                            <Route path=':userId' element={<PatientsListPage/>}/>
                        </Route>
                        <Route path='/unauthorized'
                               element={<ProtectedRoute> <UnauthorizedPage/>
                               </ProtectedRoute>}/>
                        <Route path='/follow-ups' element={<ProtectedRoute> <FollowUpPage/> </ProtectedRoute>}/>
                        <Route path='/notifications' element={<ProtectedRoute> <NotificationPage/> </ProtectedRoute>}/>
                    </Routes>
                    <Toaster position="top-right"/>
                </LayoutComponent>
            </ConfigProvider>
        </Router>
    );
}

export default App;
